import type { TAdvertiserState } from './advertiser.types';

export const ADVERTISER_INITIAL_STATE: TAdvertiserState = {
  source: {},
  fetched: false,
  loading: false,
  error: null,
};
